<template>
  <SingleSelect
    v-model="value"
    v-bind="$attrs"
    :options="transformedOptions"
    :label="label"
    :required="false"
    :pills="true"
  />
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

const props = defineProps<{
  options: Schemas['ProductSorting'][]
  selected: string | undefined
}>()

const { t } = useI18n()

const emit = defineEmits(['select'])

const value = ref<string | undefined>(props.selected)

const label = computed(() => {
  if (!value.value) {
    return t('listing.sortBy')
  }
  const selectedOption = props.options?.find(
    (option) => option.key === value.value
  )
  return getTranslatedProperty(selectedOption, 'label')
})

const transformedOptions = computed(
  () =>
    props.options?.map((option) => {
      return {
        value: option.key,
        label: getTranslatedProperty(option, 'label'),
      }
    }) || []
)

watch(value, () => {
  emit('select', value.value)
})
</script>
